export const userLangObject = () => {
    var str = [
        { name: 'English', value: 'en', translate: 'english' },
        { name: 'Spanish', value: 'es', translate: 'spanish' },
        { name: 'Portuguese', value: 'pt', translate: 'portuguese' }
    ]
    return str;
}